import { useCookie } from "@chef/hooks";

const parseOverrides = (
  overrides: null | undefined | string,
): Record<string, boolean> => {
  try {
    // @ts-expect-error may not work, in which case we return an empty object
    let parsedValue = JSON.parse(overrides);

    if (typeof parsedValue !== "object" || parsedValue === null) {
      parsedValue = {};
    }

    return parsedValue;
  } catch {
    return {};
  }
};

export const useFeatureFlagOverrides = () => {
  const { value: overrides, updateCookie } = useCookie("vercel-flag-overrides");

  const parsedOverrides = parseOverrides(overrides);

  const setOverride = (flagName: string, value: boolean) => {
    parsedOverrides[flagName] = value;
    updateCookie(JSON.stringify(parsedOverrides));
  };

  const reset = () => {
    updateCookie(null);
  };

  if (!overrides) {
    return { overrides: {}, setOverride, reset };
  }

  return { overrides: parsedOverrides, setOverride, reset };
};
